export default __webpack_public_path__ + "static/media/new_user_activity_58.56a8b3fb.png";